import type React from 'react';
import { Skeleton, Table } from '@heroui/react';
import {
    BARCODE_ISSUES_COLUMNS,
    BARCODE_ISSUES_SKELETON_KEYS,
} from './barcodeIssuesColumns';

/**
 * The rows while the first page loads (rulebook §12): one placeholder cell
 * per header, under the table's real headers, so nothing moves when the rows
 * arrive.
 */
export const BarcodeIssuesSkeleton: React.FC = () => (
    <>
        {BARCODE_ISSUES_SKELETON_KEYS.map((id) => (
            <Table.Row id={id} key={id}>
                <Table.Cell>{null}</Table.Cell>
                {BARCODE_ISSUES_COLUMNS.map((column) => (
                    <Table.Cell key={column}>
                        <Skeleton className="h-4 w-20 rounded" />
                    </Table.Cell>
                ))}
            </Table.Row>
        ))}
    </>
);
